var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagementRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 8.99859L8.09266 10.8136L11.7152 7.18359",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06266 1.83578C8.58016 1.39328 9.42766 1.39328 9.95266 1.83578L11.1377 2.85578C11.3627 3.05078 11.7827 3.20828 12.0827 3.20828H13.3577C14.1527 3.20828 14.8052 3.86078 14.8052 4.65578V5.93078C14.8052 6.22328 14.9627 6.65078 15.1577 6.87578L16.1777 8.06078C16.6202 8.57828 16.6202 9.42578 16.1777 9.95078L15.1577 11.1358C14.9627 11.3608 14.8052 11.7808 14.8052 12.0808V13.3558C14.8052 14.1508 14.1527 14.8033 13.3577 14.8033H12.0827C11.7902 14.8033 11.3627 14.9608 11.1377 15.1558L9.95266 16.1758C9.43516 16.6183 8.58766 16.6183 8.06266 16.1758L6.87766 15.1558C6.65266 14.9608 6.23266 14.8033 5.93266 14.8033H4.63516C3.84016 14.8033 3.18766 14.1508 3.18766 13.3558V12.0733C3.18766 11.7808 3.03016 11.3608 2.84266 11.1358L1.83016 9.94328C1.39516 9.42578 1.39516 8.58578 1.83016 8.06828L2.84266 6.87578C3.03016 6.65078 3.18766 6.23078 3.18766 5.93828V4.64828C3.18766 3.85328 3.84016 3.20078 4.63516 3.20078H5.93266C6.22516 3.20078 6.65266 3.04328 6.87766 2.84828L8.06266 1.83578Z",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementRequest);
export default __webpack_public_path__ + "static/media/managementRequest.49e85944.svg";
export { ForwardRef as ReactComponent };